import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="container mt-5 pt-5 mb-5">
      <h1>Privacy Policy</h1>
      <p className="text-muted">Last Updated: April 2026</p>
      
      <section className="mt-4">
        <h3>1. Introduction</h3>
        <p>
          At Trust Global, we respect your privacy and are committed to protecting the personal 
          information you share with us. This Privacy Policy explains how we collect, use, and 
          safeguard your information when you visit our website or make a purchase.
        </p>

        <h3 className="mt-4">2. Information We Collect</h3>
        <p>
          We may collect the following types of information:
        </p>
        <ul>
          <li><strong>Personal Information:</strong> Name, email address, shipping address, billing address, and phone number when you place an order or create an account.</li>
          <li><strong>Payment Information:</strong> Credit card details or other payment information (processed securely through our payment gateways; we do not store full credit card numbers on our servers).</li>
          <li><strong>Usage Data:</strong> Information about how you interact with our website, such as IP addresses, browser types, and pages visited, collected via cookies and similar tracking technologies.</li>
        </ul>

        <h3 className="mt-4">3. How We Use Your Information</h3>
        <p>
          The information we collect is used to:
        </p>
        <ul>
          <li>Process and fulfill your orders, including sending order confirmations and shipping updates.</li>
          <li>Provide customer support and respond to your inquiries.</li>
          <li>Improve our website functionality, user experience, and product offerings.</li>
          <li>Send promotional emails and newsletters (only if you have opted in to receive them).</li>
        </ul>

        <h3 className="mt-4">4. Sharing Your Information</h3>
        <p>
          We do not sell, trade, or rent your personal information to third parties. We may share 
          your information with trusted third-party service providers (such as shipping carriers and 
          payment processors) solely for the purpose of fulfilling your orders and operating our business. 
          These providers are obligated to keep your information secure and confidential.
        </p>

        <h3 className="mt-4">5. Contact Us</h3>
        <p>
          If you have any questions or concerns about this Privacy Policy or how your data is handled, 
          please contact us at <strong>info@trustglobal.com.bd</strong>.
        </p>
      </section>
    </div>
  );
};

export default PrivacyPolicy;